import React from 'react';
import AnimatedLogo from '../Layout/AnimatedLogo';
import { authCard, authTitleClass, authSubtitleClass } from './authViewTheme';

/**
 * Shared split-screen auth layout: app background + art panel (lg) + centered column.
 */
export function AuthSplitScaffold({ children }: any) {
  return (
    <div
      className="relative flex min-h-screen flex-col bg-dark-base lg:flex-row"
      style={{
        backgroundImage: 'url(/assets/layoutbackground.svg)',
        backgroundPosition: 'bottom center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% auto',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="hidden min-h-0 items-center justify-center p-6 lg:flex lg:w-1/2 xl:p-12">
        <img
          src="/assets/login_art.webp"
          alt=""
          className="max-h-[75vh] w-auto max-w-full object-contain"
        />
      </div>

      <div className="flex min-h-screen w-full flex-1 flex-col items-center justify-center px-4 py-8 sm:px-6 sm:py-10 lg:min-h-0 lg:p-8 xl:p-12">
        <div className="w-full max-w-md">{children}</div>
      </div>
    </div>
  );
}

/**
 * Auth card with header band matching Login / Forgot password styling.
 */
export function AuthSplitShell({ title, description, releaseDateLabel, children }: any) {
  return (
    <AuthSplitScaffold>
      <div className="mb-6 flex flex-col items-center gap-1">
        <span className="flex h-14 w-60 shrink-0 items-center justify-center sm:h-16 sm:w-72">
          <AnimatedLogo className="h-full w-full object-contain object-center" />
        </span>
        {releaseDateLabel ? (
          <span
            className="text-[9px] font-normal tabular-nums text-slate-500 sm:text-[10px]"
            title={`Release ${releaseDateLabel}`}
          >
            {releaseDateLabel}
          </span>
        ) : null}
      </div>
      <div className={authCard}>
        <h1 className={authTitleClass}>{title}</h1>
        {description ? <p className={authSubtitleClass}>{description}</p> : null}
        {children}
      </div>
    </AuthSplitScaffold>
  );
}

export default AuthSplitShell;
